import { render } from "./PublicTenders.vue?vue&type=template&id=7b3f40c2&scoped=true"
import script from "./PublicTenders.vue?vue&type=script&lang=js"
export * from "./PublicTenders.vue?vue&type=script&lang=js"

import "./PublicTenders.vue?vue&type=style&index=0&id=7b3f40c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b3f40c2"]])

export default __exports__